import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const ExpireContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  width: 100%;
  min-width: 0; /* Previene overflow en flex items */
`;

export const ExpireValueInput = styled.div`
  flex-shrink: 0; /* No permite que el input se encoja */
  width: 80px; /* Ancho fijo pequeño para solo números */
`;

export const ExpireUnitSelect = styled.div`
  flex: 1; /* Toma el mayor espacio disponible */
  min-width: 0; /* Permite que se encoja si es necesario */
`;

export const NeverExpiresWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0; /* Mantiene el tamaño del checkbox y texto */
  white-space: nowrap; /* Previene que el texto se parta */
`;

